import axios from "axios";
import { Config } from "config";

export const getUserIdentity = (args) => {
    return axios.get(`${Config.MyDNV.azureFnPath}/getUserIdentity`, {
        validateStatus: function (status) {
            return (status >= 200 && status < 300) || status === 403 || status === 401; // default + 403 + 401
        },
        headers: {
            Authorization: `Bearer ${args.token}`,
            "Content-Type": "application/json",
        },
    });
};

export const postVerifyEmailAddress = (args) => {
    return axios.post(`${Config.MyDNV.azureFnPath}/postVerifyEmailAddress`, args.body, {
        validateStatus: function (status) {
            return (status >= 200 && status < 300) || status === 408; // default + 408
        },
        headers: {
            Authorization: `Bearer ${args.token}`,
            "Content-Type": "application/json",
        },
    });
};

export const getEmailVerified = (args) => {
    return axios.get(`${Config.MyDNV.azureFnPath}/getEmailVerified`, {
        validateStatus: function (status) {
            return (status >= 200 && status < 300) || status === 403 || status === 401; // default + 403 + 401
        },
        headers: {
            Authorization: `Bearer ${args.token}`,
            "Content-Type": "application/json",
        },
    });
};

export const postRequestVerificationEmail = (args) => {
    return axios.post(`${Config.MyDNV.azureFnPath}/postRequestVerificationEmail`, args.body, {
        headers: {
            Authorization: `Bearer ${args.token}`,
            "Content-Type": "application/json",
        },
    });
};
